<!-- 报表下载 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card
        class="table-wrap"
        shadow="never"
        body-style="{ height: calc(100vh - 60px - 40px - 32px - 40px)}"
      >
        <div class="main-content column-flex">
          <div class="search-form">
            <el-form label-width="80px">
              <el-row :gutter="15">
                <el-col :span="4">
                  <el-form-item :label="$t('text.kssj')">
                    <el-date-picker
                      v-model="starttime"
                      type="date"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item :label="$t('text.jssj')">
                    <el-date-picker
                      v-model="endtime"
                      type="date"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('text.sbid')">
                    <el-select
                      v-model="devid"
                      :placeholder="$t('placeholder.xzid')"
                    >
                      <el-option
                        v-for="(item, index) in deviceList"
                        :key="index"
                        :label="item.key"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-button
                    icon="el-icon-video-play"
                    type="primary"
                    @click="handleQuery"
                  >{{ $t('button.yl') }}</el-button>
                  <el-button
                    icon="el-icon-download"
                    type="warning"
                    @click="handleExport"
                  >{{ $t('button.dc') }}</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="table">
            <p>{{ 'sn-'+sn }}</p>
            <el-table :data="tableData.details">
              <el-table-column
                label="更新时间"
                align="center"
              >
                <template v-slot="scope">
                  <span>{{ scope.row.hourtime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="A相电压"
                align="center"
              >
                <template v-slot="scope">
                  <span>{{ scope.row.ua ||'N/A' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="B相电压"
                align="center"
              >
                <template v-slot="scope">
                  <span>{{ scope.row.ub ||'N/A' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="C相电压"
                align="center"
              >
                <template v-slot="scope">
                  <span>{{ scope.row.uc ||'N/A' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="A相功率"
                align="center"
              >
                <template v-slot="scope">
                  <span>{{ scope.row.pac1 ||'N/A' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="B相功率"
                align="center"
              >
                <template v-slot="scope">
                  <span>{{ scope.row.pac2 ||'N/A' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="C相功率"
                align="center"
              >
                <template v-slot="scope">
                  <span>{{ scope.row.pac3 ||'N/A' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="总发电量"
                align="center"
              >
                <template v-slot="scope">
                  <span>{{ scope.row.ftotal ||'N/A' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="输出功率"
                align="center"
              >
                <template v-slot="scope">
                  <span>{{ scope.row.pac ||'N/A' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="功率因数"
                align="center"
              >
                <template v-slot="scope">
                  <span>{{ scope.row.fac ||'N/A' }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="时间"
                align="center"
              >
                <template v-slot="scope">
                  <span>{{ $parseTime(scope.row.time,'yyyy-MM-dd hh:mm:ss') }}</span>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { GetDevicesByOrgId } from '@/api/Universal'
import { GetAusHourMeterReportData, ExpAusHourMeterReport } from '@/api/Meter'

export default {
  components: {},
  data () {
    return {
      fullLoading: null,
      dateType: 'hour',
      tableData: {},
      deviceList: [],
      devid: '',
      starttime: new Date(),
      endtime: new Date(),
      split: 5,
      sn: ''
    }
  },
  computed: {

  },

  mounted () {
    this.getdeviceId(() => {
      this.handleQuery()
    })
  },
  methods: {
    getdeviceId (callback) {
      GetDevicesByOrgId({ id: this.$store.getters.station.id, tag: '3' }).then((res) => {
        this.deviceList = res.data || []
        this.devid = this.deviceList[0].value || null
        if (callback) {
          callback()
        }
      })
    },
    // 预览
    handleQuery () {
      this.fullLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      GetAusHourMeterReportData({
        dateType: this.dateType,
        split: this.split,
        startTime: this.$parseTime(this.starttime, 'yyyy-MM-dd 00:00:00'),
        endTime: this.$parseTime(this.endtime, 'yyyy-MM-dd 23:59:59'),
        orgId: this.$store.getters.station.id,
        deviceId: this.devid
      })
        .then((res) => {
          this.fullLoading.close()
          this.tableData = res.data || []
          this.sn = res.data.details[0].sn
        })
        .catch(() => {
          this.fullLoading.close()
        })
    },
    formatTime (row, column, cellValue) {
      return this.$parseTime(cellValue, 'dd-MM-yyyy hh:mm:ss')
    },
    // 导出
    handleExport () {
      this.fullLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      ExpAusHourMeterReport({
        dateType: this.dateType,
        split: this.split,
        startTime: this.starttime,
        endTime: this.endtime,
        orgId: this.$store.getters.station.id,
        deviceId: this.devid
      })
        .then(res => {
          this.fullLoading.close()
          window.location.href = res.data
        })
        .catch(() => {
          this.fullLoading.close()
        })
    }
  },
}
</script>
<style lang='stylus' scoped>
.app-container {
  margin-right: 5px;
  padding: 10px;
  background-color: #F8F8F8;
}

.el-input + .el-input {
  margin-top: 0;
}

.el-form-item.total ::v-deep label {
  cursor: not-allowed;
  color: #ccc;
}

.search-form {
  height: 60px;
}

.main-content {
  height: calc(100vh - 60px - 40px - 32px - 40px);
}

.table {
  height: calc(100% - 60px);
  overflow-y: auto;
}
.table p{
  text-align: center
  font-size 20px
  font-weight 600
  padding 10px
  border-bottom: 1px solid #EBEEF5;
}
</style>

